import { Trans, useTranslation } from 'react-i18next';
import { ALERT_CENTER_NS } from 'src/alerts/AlertCenter.constants';
import { alertBodyKeys } from 'src/alerts/AlertCenter.functions';
import type { tLiveAlert } from 'src/alerts/AlertCenter.types';

/**
 * The alert's own body sentence, rendered the way the panel renders it (the
 * `<0>` markup some bodies carry degrades to emphasis). Rich renderers that
 * keep the standard sentence compose this above their extras; a renderer with
 * its own body treatment (account-health's inline policy link) replaces it.
 */
export default function AlertDetailBody(props: { alert: tLiveAlert }) {
  const { t } = useTranslation(ALERT_CENTER_NS);
  const { values } = props.alert.copy;
  // U12 — one paragraph per independent fact. A family with a single body key
  // renders exactly the one paragraph it always did.
  const bodyKeys = alertBodyKeys(props.alert);
  if (bodyKeys.length === 0) return null;
  return (
    <>
      {bodyKeys.map((bodyKey, index) => (
        <p
          key={bodyKey}
          className="AlertDetail__Body"
          data-testid={
            index === 0 ? 'alert-detail-body' : `alert-detail-body-${index}`
          }
        >
          <Trans
            t={t}
            i18nKey={bodyKey}
            values={values ?? {}}
            components={[<span key="0" className="font-semibold" />]}
          />
        </p>
      ))}
    </>
  );
}
